module.exports = "/build/web/svg/sponsor/eredivisie.af51134d12b7dbbdbb20878202232f0f.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/eredivisie.svg
// module id = 208
// module chunks = 24